import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC52AVvBV8_HukTXkkTWXuLtqnqJGaZOwc",
  authDomain: "my-react-app-f8c51.firebaseapp.com",
  projectId: "my-react-app-f8c51",
  storageBucket: "my-react-app-f8c51.firebasestorage.app",
  messagingSenderId: "977740984057",
  appId: "1:977740984057:web:fc5c6b84df88a0566c7c28"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export default app;